export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        {/* Left Image */}
        <div className="w-full lg:w-[40%]">
          <div className="w-full h-72 md:h-96 rounded-2xl overflow-hidden bg-accent-100">
            <img
              src="https://readdy.ai/api/search-image?query=Young%20person%20browsing%20shopping%20catalog%20on%20laptop%20in%20a%20bright%20minimal%20room%2C%20natural%20window%20light%2C%20warm%20cream%20walls%2C%20modern%20casual%20style%2C%20lifestyle%20photography%2C%20clean%20aesthetic%2C%20soft%20natural%20tones&width=600&height=800&seq=testimonial-person-01&orientation=portrait"
              alt="Kakobuy Spreadsheet user browsing products"
              title="Kakobuy Spreadsheet User Experience"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>

        {/* Right Content */}
        <div className="w-full lg:w-[60%]">
          <span className="text-xs font-semibold text-accent-500 uppercase tracking-widest">
            User Feedback
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mt-3 mb-8 leading-tight">
            What Shoppers Say{' '}
            <span className="text-foreground-400">About the</span>
            <br />
            <span className="text-primary-500">Spreadsheet Database</span>
          </h2>

          <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6 italic border-l-3 border-primary-500 pl-6">
            "The Kakobuy Spreadsheet completely changed how I shop online. Instead of spending hours manually searching for products, I can browse organized categories, compare prices across platforms, and access QC photos all from one database. The buying guides are incredibly helpful for someone who was totally new to this. I have already found so many great items I would have missed otherwise."
          </blockquote>

          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-heading font-bold text-sm">
              JD
            </div>
            <div>
              <p className="font-semibold text-foreground-900 text-sm">Jordan D.</p>
              <p className="text-xs text-foreground-500">Verified Spreadsheet User</p>
            </div>
          </div>

          {/* Navigation dots */}
          <div className="flex items-center gap-3 mt-8">
            <button className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-400 hover:border-foreground-400 hover:text-foreground-600 transition-all duration-200 cursor-pointer" aria-label="Previous testimonial">
              <i className="ri-arrow-left-line"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 cursor-pointer" aria-label="Current testimonial">
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}